import { FormattedMessage } from "react-intl";
import { Tabs, TabsList, TabsTrigger } from "@lendcord/concord";

const TABS = [
  { value: "kyc", labelId: "lender.profile.tabKyc" },
  { value: "addresses", labelId: "lender.profile.tabAddresses" },
  { value: "documents", labelId: "lender.profile.tabDocuments" },
  { value: "bank-account", labelId: "lender.profile.tabBankAccount" },
  { value: "employment-details", labelId: "lender.profile.tabEmploymentDetails" },
];

interface ProfileTabsProps {
  value: string;
  onValueChange: (value: string) => void;
}

export function ProfileTabs({ value, onValueChange }: ProfileTabsProps) {
  return (
    <Tabs value={value} onValueChange={onValueChange}>
      <TabsList>
        {TABS.map((tab) => (
          <TabsTrigger
            key={tab.value}
            value={tab.value}
            className="hover:text-text data-[state=active]:bg-accent-50 data-[state=active]:font-semibold data-[state=active]:text-accent-600 data-[state=active]:shadow-none"
          >
            <FormattedMessage id={tab.labelId} />
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
